/* jshint esversion: 6 */
import PropTypes from 'prop-types';
import classnames from 'classnames';

const { __ } = wp.i18n;

const { SelectControl, Dashicon, Tooltip, Button } = wp.components;

const { Component, Fragment } = wp.element;
class SelectComponent extends Component {
	constructor() {
		super( ...arguments );
		this.updateValues = this.updateValues.bind( this );
		this.onUpdate = this.onUpdate.bind( this );
		this.linkUpdatingItem = this.linkUpdatingItem.bind( this );
		let value = this.props.control.setting.get();
		let defaultParams = {
			options: {
				standard: {
					name: __( 'Standard', 'kadence' ),
				},
				fullwidth: {
					name: __( 'Fullwidth', 'kadence' ),
				},
				contained: {
					name: __( 'Contained', 'kadence' ),
				},
			},
		};
		this.controlParams = this.props.control.params.input_attrs ? {
			...defaultParams,
			...this.props.control.params.input_attrs,
		} : defaultParams;
		let baseDefault = 'standard';
		this.defaultValue = this.props.control.params.default ? this.props.control.params.default : baseDefault;
		value = value ? value : this.defaultValue;
		const selectOptions = Object.keys( this.controlParams.options ).map( ( item ) => {
			return ( { label: this.controlParams.options[ item ].name, value: item } );
		} );
		this.state = {
			value: value,
			confirm: false,
			selectOptions: selectOptions,
		};
		this.linkUpdatingItem();
	}
	onUpdate() {
		const settings = this.props.customizer( 'conditional_headers' ).get();
		const selectDefault = [ { label: 'Default', value: '' } ];
		const selectOptions = Object.keys( settings.items ).map( ( item ) => {
			return ( { label: settings.items[ item ].label, value: settings.items[ item ].id } );
		} );
		const newOptions = selectDefault.concat( selectOptions );
		this.setState( { selectOptions: newOptions } );
	}
	render() {
		const controlLabel = (
			<Fragment>
				<Tooltip text={ __( 'Reset Value', 'kadence' ) }>
					<Button
						className="reset kadence-reset"
						disabled={ ( this.state.value === this.defaultValue ) }
						onClick={ () => {
							this.setState( { value: '', confirm: true } );
						} }
					>
						<Dashicon icon='image-rotate' />
					</Button>
				</Tooltip>
				{ this.props.control.params.label &&
					this.props.control.params.label
				}
			</Fragment>
		);
		const selectOptions = Object.keys( this.controlParams.options ).map( ( item ) => {
			return ( { label: this.controlParams.options[ item ].name, value: item } );
		} );
		return (
			<div className="kadence-control-field kadence-select-control">
				<div className="kadence-responsive-control-bar">
					<span className="customize-control-title">{ controlLabel }</span>
				</div>
				<SelectControl
					value={ this.state.value }
					options={ this.state.selectOptions }
					onChange={ ( val ) => {
						this.setState( { value: val, confirm: true } );
					} }
				/>
				{ this.state.confirm && this.state.value && (
					<div className="kadence-header-preview-info">
						<p>{ __( 'Previewing another header requires reloading the customizer in a preview mode. Click confirm below to save your settings and enter into preview mode.', 'kadence' ) }</p>
						<Button
							className="kadence-confirm"
							isPrimary
							onClick={ () => {
								this.updateValues( this.state.value );
							} }
						>
							{ __( 'Confirm, Save Settings', 'kadence' ) }
						</Button>
					</div>
				) }
				{ this.state.confirm && ! this.state.value && (
					<div className="kadence-header-preview-info">
						<Button
							className="kadence-confirm"
							isPrimary
							onClick={ () => {
								this.updateValues( this.state.value );
							} }
						>
							{ __( 'Confirm, Exit Preview Mode', 'kadence' ) }
						</Button>
					</div>
				) }
			</div>
		);
	}

	updateValues( value ) {
		this.setState( { value: value } );
		this.props.control.setting.set( value );
		var control = this;
		this.props.customizer.state('saved').bind( 'change', function() {
			if ( control.props.customizer.state( 'saved' ).get() ) {
				window.location.href = kadenceCustomizerConditionalData.header_url;
			}
		});
		this.props.customizer.previewer.save();
		// const checkSave = async => {
		// 	while ( this.props.customizer.state( 'saved' ).get() === false ) {
		// 		await new Promise( resolve => requestAnimationFrame( resolve ) )
		// 	}
		// 	return true; 
		// }
		// checkSave().then( () => {
		// 	window.location.href = kadenceCustomizerConditionalData.header_url;
		// } );
	}
	linkUpdatingItem() {
		let self = this;
		document.addEventListener( 'kadenceUpdateConditional', function( e ) {
			if ( e.detail === 'conditional_header' ) {
				self.onUpdate();
			}
		} );
	}
}

SelectComponent.propTypes = {
	control: PropTypes.object.isRequired
};

export default SelectComponent;
